var exports = {
  "kL": "xa15a2ab7--b217b3--container",
  "FU": "xa15a2ab7--b217b3--align-right",
  "Qq": "xa15a2ab7--b217b3--text",
};

module.exports = exports;
